module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "noMargin"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('div', {
    staticClass: "pageTitle"
  }, [_c('h2', [_vm._v("PRODUCTS SALES REPORTS")])]), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-5\t",
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncFilterProductSalesReports.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("filter_list")]), _vm._v("FILTER / GENERATE REPORT")]), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-5",
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncFilterProjectSalesReport.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons reloadButton"
  }, [_vm._v("refresh")])]), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": ""
    }
  }, [_c('v-toolbar-side-icon', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }), _vm._v(" "), _c('v-list', [_c('v-list-tile', [_c('v-list-tile-title', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncExportProductSales.apply(null, arguments)
      }
    }
  }, [_vm._v("Export to CSV - No details")])])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncExportProductSalesDetailed.apply(null, arguments)
      }
    }
  }, [_vm._v("Export to CSV - Detailed")])])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}